{
    "login": {
        "title": "Authorization",
        "emailLbl": "Email*",
        "passwordLbl": "Password*",
        "forgotPasswordLbl": "Forgot your password?",
        "registrationLbl": "Not registered yet? <a>Registration</a>",
        "signIn": "Sign In"
    },
    "signUp": {
        "title": "Registration",
        "submitBtn": "Sign up",
        "confirmPasswordLbl": "Repeat password*",
        "firstNameLbl": "Name*",
        "lastNameLbl": "Last name*",
        "phoneNumberLbl": "Phone",
        "companyNameLbl": "Company name",
        "companyNamePlaceholder": "Enter your company name",
        "countryLbl": "Country",
        "addressLbl": "Address",
        "addressPlaceholder": "Enter the address",
        "zipLbl": "Zip",
        "zipPlaceholder": "Enter the zip",
        "cityLbl": "City",
        "cityPlaceholder": "Enter the city",
        "companyStatus": "Status",
        "defaultCompany": "Main company",
        "tinLbl": "TIN",
        "deliveryEstimate": {
            "title": "Your approximate number of deliveries per month?",
            "lessThan5Name": "<5",
            "from5To20Name": "5-20",
            "from21To50Name": "21-50",
            "moreThan50Name": "> 50"
        },
        "consent": "I consent to the processing of my personal data in accordance with the <a>Terms and Conditions</a> and accept it. You are also aware of and agree to the <b>Cookie Policy</b>"
    },
    "confirmEmail": {
        "successAlert": "Verification successful, you can now login.",
        "errorAlert": "Verification failed, you can also verify your account using the forgot password page."
    },
    "goToLogin": "Go to Login",
    "alert": {
        "checkEmail1": "We have sent the code to your email,",
        "checkEmail2": "check your mail",
        "changePasswordTitle": "Password changed",
        "changePasswordContent1": "You can now log in to your account with",
        "changePasswordContent2": "your new password"
    },
    "forgotPassword": {
        "title": "Password recovery",
        "content": "Enter your email to reset your password"
    },
    "changePassword": {
        "title": "Change password",
        "description": "To change your password, please enter your current password and then create a new one.",
        "currentPassword": "Current Password",
        "newPassword": "New Password",
        "confirmNewPassword": "Confirm New Password",
        "content": "Enter and confirm your new password",
        "sendBtn": "Update password",
        "changePasswordBtn": "Change password"
    }
}